<template>
    <path d="M 18.650593,3.6262712 8.944322,13.332542 5.3494068,9.7376271 1.7288136,13.35822 8.944322,20.573729 22.271186,7.2468644 Z"/>
</template>

<script>
    export default {
        name: 'done',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Done.vue